import { gql } from '@apollo/client';
import { CheckoutBasicFieldsFragment } from '../../fragments/checkout/CheckoutBasicFields.gql';
import { CheckoutUserFieldsFragment } from '../../fragments/checkout/CheckoutUserFields.gql';
import { CheckoutPricingFieldsFragment } from '../../fragments/checkout/CheckoutPricingFields.gql';
import { CheckoutExtendedFieldsFragment } from '../../fragments/checkout/CheckoutExtendedFields.gql';
import { LinesForAnalyticsFieldsFragment } from '../../fragments/checkout/LinesForAnalyticsFields.gql';
import { LinesBasicFieldsFragment } from '../../fragments/checkout/LinesBasicFields.gql';

const CHECKOUT_SHIPPING_ADDRESS_REMOVE_MUTATION = gql`
    ${CheckoutBasicFieldsFragment}
    ${CheckoutUserFieldsFragment}
    ${CheckoutPricingFieldsFragment}
    ${CheckoutExtendedFieldsFragment}
    ${LinesForAnalyticsFieldsFragment}
    ${LinesBasicFieldsFragment}
    mutation CheckoutShippingAddressRemove($checkout: ID!) {
        checkoutShippingAddressRemove(checkoutId: $checkout) {
            checkout {
                ...CheckoutBasicFields
                ...CheckoutUserFields
                ...CheckoutPricingFields
                ...CheckoutExtendedFields
                lines {
                    ...LinesBasicFields
                    ...LinesForAnalyticsFields
                }
            }
            errors {
                message
                field
            }
        }
    }
`;

export default CHECKOUT_SHIPPING_ADDRESS_REMOVE_MUTATION;
